import { ol_Extent, ol_source, ol_layer } from "@omnia/exports/openlayers"
import { isArray, isObject } from "../../omnia"
import { Imagery, IMap } from "../types"
import ImageSource from "ol/source/Image"

interface PreviewSetupDelay {
    readonly setup: PromiseLike<any>
    cancel()
}

export class Preview {


    public static create(preview: Imagery, map: IMap, delay: PreviewSetupDelay, visible: boolean) {

        const layer = new PictureLayer()
        layer.setup(preview.imageUrl, preview.extent, map, delay, visible)

        return new Preview(preview, layer)

    }

    public static dispose(previews: Preview[], map: IMap) {

        if (isArray(previews) && isObject(map)) {
            previews.forEach(p => p.layer.removeFromMap(map))
        }

    }

    private constructor(public readonly preview: Imagery, private readonly layer: PictureLayer) {
    }

    get fieldId() {
        return this.preview.fieldId
    }

    get visible() {
        return this.layer.visible
    }

    set visible(value) {
        this.layer.visible = value
    }

}

class PictureLayer extends omnia.map.Layer {

    private _delay: PreviewSetupDelay
    private _imgLayer: ol_layer.Image<ImageSource>

    public setup(url: string, extent: ol_Extent, map: IMap, delay: PreviewSetupDelay, visible: boolean) {

        this._delay = delay

        delay.setup.then(() => {

            const source = new ol_source.ImageStatic({
                imageExtent: extent,
                url: url,
                projection: "EPSG:4326"
            })

            this._genericLayer = this._imgLayer = new ol_layer.Image({
                source
            })

            this.visible = visible

            this.addToMap(map)

        })

    }

    addToMap(map: IMap) {

        if (this._imgLayer) {
            map.pictureLayersGroup.getLayers().push(this._imgLayer)
        }

    }

    removeFromMap(map: IMap) {

        if (this._imgLayer) {
            map.pictureLayersGroup.getLayers().remove(this._imgLayer)
        }

        if (this._delay) {
            this._delay.cancel()
            this._delay = undefined
        }

    }

}
